module.exports = __webpack_public_path__ + "static/media/2.5fd207e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/instructorsPhoto/2.jpg
// module id = 243
// module chunks = 1